import { render, staticRenderFns } from "./card_status.vue?vue&type=template&id=22a74451&scoped=true&"
import script from "./card_status.vue?vue&type=script&lang=js&"
export * from "./card_status.vue?vue&type=script&lang=js&"
import style0 from "./card_status.vue?vue&type=style&index=0&id=22a74451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a74451",
  null
  
)

export default component.exports